import _regeneratorRuntime from "/Users/dom/src/deeplocal/maps-tycoon-2020/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import _classCallCheck from "/Users/dom/src/deeplocal/maps-tycoon-2020/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/dom/src/deeplocal/maps-tycoon-2020/node_modules/@babel/runtime/helpers/esm/createClass";
import { isReduced } from "../reduced";
export function range(from, to, step) {
  return new Range(from, to, step);
}
/**
 * Simple class wrapper around given range interval and implementing
 * `Iterable` and `IReducible` interfaces, the latter is used to
 * accelerate use with `reduce`.
 */

export var Range =
/*#__PURE__*/
function () {
  function Range(from, to, step) {
    _classCallCheck(this, Range);

    if (from === undefined) {
      from = 0;
      to = Infinity;
    } else if (to === undefined) {
      to = from;
      from = 0;
    }

    step = step === undefined ? from < to ? 1 : -1 : step;
    this.from = from;
    this.to = to;
    this.step = step;
  }

  _createClass(Range, [{
    key: Symbol.iterator,
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function value() {
      var step, to, from;
      return _regeneratorRuntime.wrap(function value$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              step = this.step;
              to = this.to;
              from = this.from;

              if (!(step > 0)) {
                _context.next = 12;
                break;
              }

            case 4:
              if (!(from < to)) {
                _context.next = 10;
                break;
              }

              _context.next = 7;
              return from;

            case 7:
              from += step;
              _context.next = 4;
              break;

            case 10:
              _context.next = 19;
              break;

            case 12:
              if (!(step < 0)) {
                _context.next = 19;
                break;
              }

            case 13:
              if (!(from > to)) {
                _context.next = 19;
                break;
              }

              _context.next = 16;
              return from;

            case 16:
              from += step;
              _context.next = 13;
              break;

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, value, this);
    })
  }, {
    key: "$reduce",
    value: function $reduce(rfn, acc) {
      var step = this.step;

      if (step > 0) {
        for (var i = this.from, n = this.to; i < n && !isReduced(acc); i += step) {
          acc = rfn(acc, i);
        }
      } else {
        for (var _i = this.from, _n = this.to; _i > _n && !isReduced(acc); _i += step) {
          acc = rfn(acc, _i);
        }
      }

      return acc;
    }
  }]);

  return Range;
}();